import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Popover } from "@air/primitive-popover";
import { useBreakpointsContext } from "@air/provider-media-query";
import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { MobileFiltersContainer } from "~/components/Filters/FiltersButton/MobileFiltersContainer";
import { FILTERS_DROPDOWN } from "~/constants/testIDs";
import { removeFiltersWithoutSelectionAction } from "~/store/filters/actions";
export const FiltersDropdownTrigger = /*#__PURE__*/ memo((param)=>{
    let { renderFiltersDropdown, renderTrigger } = param;
    const triggerRef = useRef(null);
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const { isAboveMediumScreen } = useBreakpointsContext();
    const dispatch = useDispatch();
    const toggleIsPopoverOpen = useCallback(async ()=>{
        setIsPopoverOpen((isOpen)=>!isOpen);
    }, []);
    useEffect(()=>{
        // TODO: strange bug with html overflow - when lots of filters are applied, html shows vertical scrollbar
        if (isPopoverOpen) {
            document.getElementsByTagName("html").item(0).style.overflow = "hidden";
        } else {
            document.getElementsByTagName("html").item(0).style.removeProperty("overflow");
            dispatch(removeFiltersWithoutSelectionAction());
        }
    }, [
        isPopoverOpen,
        dispatch
    ]);
    const popoverContent = useMemo(()=>/*#__PURE__*/ _jsx("div", {
            className: "flex flex-1 flex-col",
            "data-testid": FILTERS_DROPDOWN,
            children: renderFiltersDropdown({
                closePopover: toggleIsPopoverOpen
            })
        }), [
        renderFiltersDropdown,
        toggleIsPopoverOpen
    ]);
    const triggerProps = useMemo(()=>({
            isActive: isPopoverOpen,
            ref: triggerRef,
            onClick: toggleIsPopoverOpen
        }), [
        isPopoverOpen,
        toggleIsPopoverOpen
    ]);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: !isAboveMediumScreen ? /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                renderTrigger(triggerProps),
                isPopoverOpen && /*#__PURE__*/ _jsx(MobileFiltersContainer, {
                    onClose: toggleIsPopoverOpen,
                    content: popoverContent
                })
            ]
        }) : /*#__PURE__*/ _jsx(Popover, {
            className: "flex max-h-[calc(100vh-72px)] w-[100vw-48px] min-w-[400px] max-w-[400px] overflow-hidden p-0 md:max-h-[70vh]",
            onOpenChange: setIsPopoverOpen,
            open: isPopoverOpen,
            trigger: renderTrigger(triggerProps),
            children: popoverContent
        })
    });
});
FiltersDropdownTrigger.displayName = "FiltersTrigger";
